import React, { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface PositioningContainerProps<OptionType extends CascaderOption>
  extends BoxProps {
  children: React.ReactNode;
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalPositioningContainer = <
  OptionType extends CascaderOption,
>({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { cascaderStyles, comboboxApi, getCommonProps } =
    useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomPositioningContainer = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.POSITIONING_CONTAINER),
    [getComponent],
  );

  return (
    <CustomPositioningContainer
      getCommonProps={getCommonProps}
      __css={cascaderStyles.positioningContainer}
      {...comboboxApi.getPositionerProps()}
      className="cascader-positioning-container"
    >
      {children}
    </CustomPositioningContainer>
  );
};

export const PositioningContainer = <OptionType extends CascaderOption>({
  children,
  getCommonProps: _,
  ...rest
}: PositioningContainerProps<OptionType>) => {
  return <Box {...rest}>{children}</Box>;
};
